import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { ProcessingStatusModel, ProcessingStatusModelDetails } from './processing-status-models-model';

@Injectable({
  providedIn: 'root'
})
export class ProcessingStatusModelService {

  constructor(private httpService: HttpService) { }

  public getProcessingStatusModels(): Observable<ProcessingStatusModel[]> {
    return this.httpService.postWithContext(environment.processingStatusModelAdminEndpoint, {});
  }

  public getProcessingStatusModelDetails(statusModelId: number): Observable<ProcessingStatusModelDetails> {
    return this.httpService.postWithContext(environment.processingStatusModelAdminEndpoint + '/details', statusModelId);
  }

  public save(details: ProcessingStatusModelDetails): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.processingStatusModelAdminEndpoint + '/save', details);
  }

  public delete(statusModelId: number): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.processingStatusModelAdminEndpoint + '/delete', statusModelId);
  }

}
